/**
 * utils.js
 * Namespace: window.fnapp
 */
(function(NS, $, undefined) {
	/**
	 * updateQueryParam
	 * Adds or updates a URL query parameter
	 *
	 * @param string url
	 * @param string key - The query key to add/update
	 * @param string value - The new query value
	 *
	 * Source: https://stackoverflow.com/questions/5999118/add-or-update-query-string-parameter
	 */
	NS.updateQueryParam = function(url, key, value) {
		if (!url) url = window.location.href;
		var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
			hash;

		if (re.test(url)) {
			if (typeof value !== 'undefined' && value !== null)
				return url.replace(re, '$1' + key + "=" + value + '$2$3');
			else {
				hash = url.split('#');
				url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
				if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
					url += '#' + hash[1];
				return url;
			}
		}
		else {
			if (typeof value !== 'undefined' && value !== null) {
				var separator = url.indexOf('?') !== -1 ? '&' : '?';
				hash = url.split('#');
				url = hash[0] + separator + key + '=' + value;
				if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
					url += '#' + hash[1];
				return url;
			}
			else
				return url;
		}
	}

	/**
	 * scrollbarWidth
	 * Get width of browser scrollbar
	 * Original function by okfocus
	 */
	NS.scrollbarWidth = function() {
		var outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.width = '100px';
		outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

		document.body.appendChild(outer);

		var widthNoScroll = outer.offsetWidth;
		outer.style.overflow = 'scroll';

		// Add innerdiv
		var inner = document.createElement('div');
		inner.style.width = '100%';
		outer.appendChild(inner);        

		var widthWithScroll = inner.offsetWidth;

		// remove divs
		outer.parentNode.removeChild(outer);

		return widthNoScroll - widthWithScroll;
	}
}(window.fnapp = window.fnapp || {}, jQuery));
/**
 * preloader.js
 * Namespace: window.fnapp
 */
(function(NS, $, undefined) {
    /**
     * Preloader
     * A class for preloading assets
     * Currently designed for loading images
     */
    NS.Preloader = function() {
		this.pageLoaded = false;
		this.imagesPreloaded = false;
		this.imagesToPreload = []; // array of URLs
		this.preloadInterval; // setInterval instance
		this.startTime = new Date().getTime();
		this.totalImgs = 0;
		this.remainingImgs = 0;
		this.percentageComplete = 0;
		this.minTime = 0;
		this.maxTime = 0;
		this.onImgLoad; // Alias for callback function passed to preloadImages constructor
		this.onComplete; // Alias for callback function passed to preloadImages constructor

		// Page loaded flag
		$(window).on('load', function() {
			console.log('page loaded');
			this.pageLoaded = true;
		});
    }

	/**
	 * Preload images
	 * Source: http://stackoverflow.com/questions/8264528/image-preloader-javascript-that-supports-events/8265310#8265310
	 * Dependencies: imagesLoaded plugin
	 */
	NS.Preloader.prototype.preloadImages = function(srcs, onImgLoad, onComplete, minTime, maxTime) {
		var img;
		this.onImgLoad = onImgLoad;
		this.onComplete = onComplete;
		this.minTime = typeof minTime !== 'undefined' ? minTime : 0;
		this.maxTime = typeof maxTime !== 'undefined' ? maxTime : 8000;
		this.totalImgs = srcs.length;
		this.remainingImgs = srcs.length;
		this.percentageComplete = 0;
		var _this = this;
		
		if (this.remainingImgs === 0) {
			onComplete();
			return;
		}

		for (var i = 0; i < this.totalImgs; i++) {
			console.log('Preloading:' + srcs[i]);
			$imgWrap = $('<div><img src="' + srcs[i] + '" /></div>');
			$imgWrap.find('img').src = srcs[i];
			$imgWrap.imagesLoaded().done( function( instance ) {
				// console.log($(instance.elements[0]).find('img')[0].src);
				// console.log('DONE  - all images have been successfully loaded');
				_this.imageComplete($(instance.elements[0]).find('img')[0].src);
			});
			$imgWrap.imagesLoaded().fail( function( instance ) {
				_this.imageComplete();
			});
		}

		// Poll for image & page load.
	    this.preloadInterval = window.setInterval(function() {
			var time = new Date().getTime();
			var elapsed = time - _this.startTime;
			if ((elapsed > _this.maxTime) || (_this.imagesPreloaded && elapsed > _this.minTime)) {
				console.log('done');
				window.clearInterval(_this.preloadInterval);
				_this.onComplete();
			}
	    }, 500);
	}
	NS.Preloader.prototype.imageComplete = function(imgSrc) {
		--this.remainingImgs;
		// Percentage could be used to update a progress bar
		this,percentageComplete = Math.ceil((this.totalImgs - this.remainingImgs) / this.totalImgs * 100);
		this.onImgLoad(imgSrc);
		if (this.remainingImgs <= 0) {
			this.imagesPreloaded = true;
		}
	}
}(window.fnapp = window.fnapp || {}, jQuery));
/**
  * scrollresize.js
  * Namespace: window.fnapp_scrollresize
  *
  * Register listeners for the resize and scroll events or retrieve
  * the current window size and scroll position.
  *
  * Add a scroll/resize listener:
  * NS.addScrollresizeListener({
  *   resize: function(winW, winH, viewportW, viewportH) { ... },
  *   scroll: function(scrollTop, scrollLeft) { ... }
  * });
  *
  * Get current scroll position:
  * scrollPos().top
  * scrollPos().left
  *
  * Get current window/viewport size:
  * winSize().winW
  * winSize().winH
  * winSize().viewportW
  * winSize().viewportH
 */
(function(NS, $, undefined) {
	var listeners = [];
	var resizeFrameQueued = false;
	var scrollFrameQueued = false;
	var scrollTop = $(window).scrollTop();
	var scrollLeft = $(window).scrollLeft();
	var winW = $(window).width();
	var winH = $(window).height();
	var viewportW = viewport().width;
	var viewportH = viewport().height;

	function addListener(listener, trigger) {
		listeners.push(listener);
		if (trigger) {
			queueResize();
		}
	}

	function removeListener(listener) {
		for (var i = 0; i < listeners.length;) {
			if (listeners[i] === listener) {
				var rest = listeners.slice(i + 1);
				listeners.length = i;
				listeners.push.apply(listeners, rest);
			} else {
				// only increment if listeners is unchanged
				i++;
			}
		}
	}

	function handleResize() {
		winW = $(window).width();
		winH = $(window).height();
		viewportW = viewport().width;
		viewportH = viewport().height;
		for (var i = 0, l = listeners.length; i < l; i++) {
			if (listeners[i].resize) listeners[i].resize(winW, winH, viewportW, viewportH);
		}
		resizeFrameQueued = false;
		handleScroll();
	}

	function queueResize() {
		if (!resizeFrameQueued) {
			resizeFrameQueued = true;
			window.requestAnimationFrame(handleResize);
		}
	}

	function handleScroll() {
		scrollTop = $(window).scrollTop();
		scrollLeft = $(window).scrollLeft();
		for (var i = 0, l = listeners.length; i < l; i++) {
			if (listeners[i].scroll) listeners[i].scroll(scrollTop, scrollLeft);
		}
		scrollFrameQueued = false;
	}

	function queueScroll() {
		if (!scrollFrameQueued) {
			scrollFrameQueued = true;
			window.requestAnimationFrame(handleScroll);
		}
	}

	function winSize() {
		return { winW: winW , winH: winH, viewportW: viewportW , viewportH: viewportH };
	}

	function scrollPos() {
		return { top: scrollTop , left: scrollLeft };
	}

	/**
	 * viewport
	 * Get accurate viewport width/height
	 * usage: viewport().width or viewport().height
	 */
	function viewport() {
		var e = window, a = 'inner';
		if (!('innerWidth' in window )) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	}

	// Bind to the resize and scroll events
	$(window).on('resize', queueResize);
	$(window).on('scroll', queueScroll);

	// Expose public methods
	NS.addScrollresizeListener = addListener;
	NS.removeScrollresizeListener = removeListener;
	NS.winSize = winSize;
	NS.scrollPos = scrollPos;
}(window.fnapp = window.fnapp || {}, jQuery));

/**
 * nav.js
 * Namespace: window.fnapp
 */
 (function(NS, $, undefined) {
	var menuDrawerOpen = false;
	var shopDrawerOpen = false;
	var aboutDrawerOpen = false;
	var ingredientsDrawerOpen = false;
	var cartDrawerOpen = false;

	function navInit() {
		// Toggle mobile menu
		$('.navbar__btn--menu-toggle').on('mousedown', function() {
			openDrawer('mobile-menu');
		});

		// Toggle search
		$('.navbar__btn--search').on('click', function() {
			$('.navbar__search-form').addClass('active');
			$('.navbar__search-form form input').focus();
			
		});
		$('.navbar__search-close').on('click', function() {
			$('.navbar__search-form').removeClass('active');
			$('.navbar__search-form form input').blur();
		});

		$('.navbar__btn--shop').on('click', function() {
			openDrawer('shop');
		});

		$('.navbar__btn--about').on('click', function() {
			openDrawer('about');
		});

		$('.js-more-ingredients').on('click', function() {
			openDrawer('ingredients');
		});

		$('.js-cart-drawer-btn').on('click', function(e) {
			e.preventDefault();
			openDrawer('cart');
		});

		// Close nav drawers on click outside
		// @see https://stackoverflow.com/questions/43249339/detect-clicks-outside-of-specific-div-and-all-of-its-children
		$(document).click(function (e) {
			// Check if the clicked area is not the menu drawer or one of its children
			if (shopDrawerOpen) {
				var container = document.getElementsByClassName('drawer--shop')[0];
				if (container !== e.target && !container.contains(e.target)) {
					closeDrawer('shop');
				}
			} else if (aboutDrawerOpen) {
				var container = document.getElementsByClassName('drawer--about')[0];
				if (container !== e.target && !container.contains(e.target)) {
					closeDrawer('about');
				}
			} else if (ingredientsDrawerOpen) {
				var container = document.getElementsByClassName('drawer--ingredients')[0];
				if (container !== e.target && !container.contains(e.target)) {
					closeDrawer('ingredients');
				}
			} else if (cartDrawerOpen) {
				var container = document.getElementsByClassName('drawer--cart')[0];
				if (container !== e.target && !container.contains(e.target)) {
					closeDrawer('cart');
				}
			}
		});

		$('.drawer__close').on('click', function(e) {
			e.preventDefault();
			closeDrawer($(this).closest('.drawer').data('drawer'));
		});
	}

	function openDrawer(drawer, loadCart) {
		console.log('opendrawer');
		// If opening cart drawer, and not explicitly told to skip cart loading
		if (drawer === 'cart' && (loadCart === true || loadCart === undefined)) {
			// And if cart has not already been loaded
			if (!$('#cart-container > *').length) {
				ajaxCart.load();
			}
		}
		$('html').addClass('drawer-open ' + drawer + '-drawer-open');
		$('.drawer[data-drawer=' + drawer + '] .drawer__link-list li').addClass('reveal--done');
		// Timeout ensures our 'click outide' listener doesn't fire prematurely
		window.setTimeout(function() {
			if (drawer === 'mobile-menu') {
				menuDrawerOpen = true;
			} else if (drawer === 'shop') {
				shopDrawerOpen = true;
			} else if (drawer === 'about') {
				aboutDrawerOpen = true;
			} else if (drawer === 'ingredients') {
				ingredientsDrawerOpen = true;
			} else if (drawer === 'cart') {
				cartDrawerOpen = true;
			}
		 }, 500);
	}

	function closeDrawer(drawer) {
		$('html').addClass('drawer-closing').removeClass('drawer-open ' + drawer + '-drawer-open');
		window.setTimeout(function() {
			$('html').removeClass('drawer-closing');
			$('.drawer[data-drawer=' + drawer + '] .drawer__link-list li').removeClass('reveal--done');
			if (drawer === 'mobile-menu') {
				menuDrawerOpen = false;
			} else if (drawer === 'shop') {
				shopDrawerOpen = false;
			} else if (drawer === 'about') {
				aboutDrawerOpen = false;
			} else if (drawer === 'ingredients') {
				ingredientsDrawerOpen = false;
			} else if (drawer === 'cart') {
				cartDrawerOpen = false;
			}
		}, 500);
	}

	// Expose public methods
	NS.navInit = navInit;
	NS.openDrawer = openDrawer;
	NS.closeDrawer = closeDrawer;

}(window.fnapp = window.fnapp || {}, jQuery));
/**
* app.js
* Namespace: window.fnapp
*
* @author Forde + Nicol (fordenicol.com)
*/
(function(NS, $, undefined) {
	var loadIndicatorTimeout;
	var scrollTop = 0;
	var prevScrollTop = 0;

	function init() {

		var _this = this;

		// Create a pageLoader instance for loading page content via AJAXLoader
		// ----------------------------------------

		// if (window.history && window.history.pushState) {
		// 	// Track artist pages, so we can toggle banner image @see artist.js
		// 	var isArtistPage = $('body').hasClass('single-suttonartist');
		// 	NS.pageLoader = new NS.PageLoader({
		// 		selector: '.ajax-link, .nav-primary a:not([href^="#"])',
		// 		initialState: { 'isArtistPage' : isArtistPage },
		// 		overwritePageTitle: true,
		// 		overwriteBodyClass: false,
		// 		scrollRestoration: false
		// 	});
		// }

		// Kill # links. They mess up AJAX loading since they trigger a popstate
		$('body').on('click', 'a[href="#"]', function(e) {
			e.preventDefault();
		});

		// Preload images
		// ----------------------------------------

		var imagesToPreload = []; // array of URLs
		var screenW = Math.max(screen.width, screen.height);

		// First data-preload image
		if (screenW < 900) {
			$('[data-preload-sm]:lt(1)').each(function(){
				imagesToPreload.push($(this).attr('data-preload-sm'));
			});
		} else {
			$('[data-preload]:lt(1), [data-background]:lt(1)').each(function(){
				imagesToPreload.push($(this).attr('data-preload'));
			});
		}
		// No data-src image? Load first regular image
		// if (!imagesToPreload.length) {
		// 	$('img[src]:lt(1)').each(function(){
		// 		imagesToPreload.push($(this).attr('src'));
		// 	});
		// }

		// Create an image preloader instance
		showPageLoader();
		var preloader = new NS.Preloader();
		preloader.preloadImages(imagesToPreload, 
			function(img) {
				// onImgLoad callback
			},
			function() {
				// onComplete callback
				console.log('All images preloaded');
				hidePageLoader();
				// Give loader time to fade out then render page
				window.setTimeout(function() {
					renderPage();
				}, 500);
			}, 0, 8000);

		// Setup navigation menu
		// ----------------------------------------

		NS.navInit();

		// Scroll listener
		// ----------------------------------------
		NS.addScrollresizeListener({
			resize: function(winW, winH, viewportW, viewportH) {
				scaleStickyCover();
			},
			scroll: function(top, scrollLeft) {
				scrollTop = top;
				// do stuff where you need to compare scrollTop against prevScrollTop...
				prevScrollTop = top;
			}
		});
	}

	/**
	* Show page loader
	*/
	function showPageLoader(delay) {
		delay = delay || 1500;
		clearTimeout(loadIndicatorTimeout);
		loadIndicatorTimeout = setTimeout(function() {
	 		TweenMax.to($('.loader--page'), 0.25, {opacity:1, display:'block'});
		}, delay);
	}

	/**
	* Hide page loader
	*/
	function hidePageLoader() {
		clearTimeout(loadIndicatorTimeout);
	 	TweenMax.to($('.loader--page'), 0.25, {opacity:0, display:'none'});
	}

	/**
	* Render page
	*/
	function renderPage() {
		setupContent();

	 	// Fade in content
    	TweenMax.to($('.fade-on-load'), 1, {'opacity': 1, onComplete: startRevealAnims});
	}

	/**
	* Initialize content after an AJAX load or page render
	*/
	function setupContent() {
		// Initialize template-specific scripts
		if ($('body').hasClass('template-index')) {
			NS.homeInit();
		}
		if ($('body').hasClass('template-product')) {
			NS.productInit();
		}
		// NS.cartInit();
		setupStickyCovers();
		setupRevealOnScrollAnims();
		setupTeaserHovers();
	}

	/**
	 * Start reveal-on-load animations
	 */
	function startRevealAnims() {
		$('.reveal:not(.js-reveal-defer):not(.js-reveal-on-scroll)').addClass('reveal--done');
	}

	/**
	 * Setup reveal-on-scroll animations
	 */
	function setupRevealOnScrollAnims(elems){
		$('.js-reveal-on-scroll').each(function(i, elem) {
			var $this = $(this);
			var $watcher = scrollMonitor.create($this.get(0), -150);

			$watcher.enterViewport(function() {
				$(elem).addClass('reveal--done');
			});
		});
		// Trigger a scroll event to make sure that any "just out of view"
		// elements are detected and slide in!
		window.setTimeout(function() {
			$(window).scroll();
		}, 10);
	}

	/**
	 * Setup sticky covers
	 */
	function setupStickyCovers() {
		var $cover = $('.cover-and-cards__cover');
		scaleStickyCover();
		$cover.hcSticky({
			stickTo: ".cover-and-cards",
			top: 91, // 1px > navbar, so cover is sticky b4 user scrolls (avoid stuck/unstuck jump).
			         // -1 margin-top is applied to element when stuck to compensate
			innerTop: 0,
			bottom: 0,
			responsive: {
				1200: {
					disable: true
				}
			}
		});
		// Be nice to Firefox
		window.setTimeout(function() {
			$('.cover-and-cards__cover').hcSticky('refresh');
		}, 2000);
	}
	  
	/**
	 * Scale sticky covers
	 * Cover will be viewport height or height of cards, whichever is less
	 */
	function scaleStickyCover() {
		var $cover = $('.cover-and-cards__cover');
		var hasIntro = $('.cover-and-cards__intro').length;
		var cardsH = 0;
		var prevCardH = 0;
		if (hasIntro) {
			cardsH += $('.cover-and-cards__intro').outerHeight();
		}
		$('.cover-and-cards__cards > *:not(.cover-and-cards__intro):not(.product-thumb--dummy)').each(function(index) {
			var $inner = $(this).children('*').first();
			var innerH = $inner.outerHeight();
			if (index > 1 || hasIntro) {
				innerH += 1;
			}
			if ((index+1)%2 === 0) {
				// If card is in the right-hand col and is taller than the card in the 
				// left-hand col, add the difference.
				if (innerH > prevCardH) {
					cardsH += innerH - prevCardH;
				}
			} else {
				cardsH += innerH;
			}
			prevCardH = innerH;
		});
		// minH ensures height is never less than .page-wrap, so no gap between cards and footer
		var minH = NS.winSize().viewportH - $('.navbar').height() - $('.footer').height();
		cardsH = Math.max(cardsH, minH); 
		$cover.css({
			'height': Math.min(NS.winSize().viewportH, cardsH)
		});
	}

	function setupTeaserHovers() {
		if ($('.img-text-teaser-img-wrap[data-teaser-index]').length) {
			$('.img-text-teaser').on('mouseenter', function() {
				$('.img-text-teaser-img-wrap[data-teaser-index=' + $(this).data('teaser-index') + ']').addClass('active');
			 });
			 $('.img-text-teaser').on('mouseleave', function() {
				$('.img-text-teaser-img-wrap[data-teaser-index=' + $(this).data('teaser-index') + ']').removeClass('active');
			 });
		}

		document.querySelectorAll('.product-thumb__image.has-hover-effect').forEach((image) => {
			image.addEventListener('mouseover', function () {
				this.classList.add('hovering');
			});
			image.addEventListener('mouseout', function () {
				this.classList.remove('hovering');
			});
		});
	}

	// Expose public methods
	NS.init = init;
	NS.showPageLoader = showPageLoader;
	NS.hidePageLoader = hidePageLoader;
	NS.setupContent = setupContent;

	// Kick off the application
	jQuery(document).ready(function ($) {
		NS.init();
	}(jQuery));
}(window.fnapp = window.fnapp || {}, jQuery));
/**
 * home.js
 * Namespace: window.fnapp
 */
 (function(NS, $, undefined) {

 	function homeInit() {
		 
 	}
	NS.homeInit = homeInit;
	
 }(window.fnapp = window.fnapp || {}, jQuery));
/**
 * product.js
 * Namespace: window.fnapp
 */
 (function(NS, $, undefined) {

	var galleryAnimInProgress = false;

 	function productInit() {

		// Gift card variants (denominations use the default Shopify <select>, but
		// we use Choice.js to make it pretty
		$('.js-select2').select2({
			minimumResultsForSearch: Infinity // hide search
		});

		// For other products we hide the <select> and show radio buttons instead. 
		// When a new radio is selectes we update the <select>
		$('.product-radio-option').on('change', function() {
			var selectedRadios = [];
			$('.product-radio-option:checked').each(function() {
				selectedRadios.push($(this).val());
			});
			var variantName = selectedRadios.join(' / ');
			// productVariantsForRadio is declared in snippets/teme-options.liquid and
			// defined in sections/product.liquid
			var variantID = Theme.productVariantsForRadio[variantName];

			// Update URL: ?variant=ID
			// Required for the Shopidy Subscriptions app to work, since it onserves the URL to tell
			// when the selected variant has changed.
			const url = new URL(window.location.href);
			url.searchParams.set('variant', variantID);
			window.history.replaceState(null, null, url);

			$('#ProductSelect--product-template').val(variantID);
			$('#ProductSelect--product-template')[0].dispatchEvent(new Event('change'));
		});
		
		// Update price and image after a new variant is selected
		$('#ProductSelect--product-template').on('change', function() {
			console.log('new product variant selected');

			var $selectedOption = $('#ProductSelect--product-template option:selected');
			var available = $selectedOption.data('available'); // will be "true" or "false" which jQ data() converts to boolean
			var price = $selectedOption.data('price');
			// var compareAtPrice = $selectedOption.data('compare-at-price');
			var $buyBtn = $('#add-to-cart');
			
			// Update price and toggle visiblility of out-of-stock label
			if (available) {
				$buyBtn.removeClass('disabled').removeAttr('disabled');
				$('.product-single__price').html(price);
				$('.add-to-cart__available').show();
				$('.add-to-cart__unavailable').hide();
			} else {
				$buyBtn.addClass('disabled').attr('disabled', 'disabled');
				$('.add-to-cart__available').hide();
				$('.add-to-cart__unavailable').show();
			}

			var imageID = $selectedOption.data('image-id');
			if (imageID && imageID !== null) {
				renderProductImage(imageID);
			}
		
		});

		$( window ).on('load', function() {
			// Preload large gallery images
			$('.product__gallery-thumb').each(function() {
				var src = $(this).find('img').data('high-res-url');
				img = new Image();
        		img.src = src;
			});
		});

		$('.product__gallery-thumb').on('click', function() {
			renderProductImage($(this).data('image-id'));
		});

		// Load recommended products
		loadProductRecommendationsIntoSection();
		// If your section has theme settings, the theme editor
		// reloads the section as you edit those settings. When that happens, the
		// recommendations need to be fetched again.
		// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
		document.addEventListener("shopify:section:load", function(event) {
			if (event.detail.sectionId === "product-recommendations") {
				loadProductRecommendationsIntoSection();
			}
		});

		// Shopify Subscriptions app
		$('.shopify_subscriptions_app_block_label_children').hide();
		document.querySelectorAll('.shopify_subscriptions_app_block input[type="radio"]').forEach((radio) => {
			radio.addEventListener('change', function () {
				// Toggle subscription options visibility
				if (this.dataset.radioType === 'selling_plan_group') {
					$('.shopify_subscriptions_app_block_label_children').slideDown();
				} else if (this.dataset.radioType === 'one_time_purchase') {
					$('.shopify_subscriptions_app_block_label_children').slideUp();
				}
			});
		});
		// $('.shopify_subscriptions_app_block_label input[data-radio-type="selling_plan_group"]').on('change', function() {
		// 	// Preload large gallery images
		// 	console.log('changed');
		// 	// $('.shopify_subscriptions_app_block_label_children').slideUp();
		// });
		 
 	}
	NS.productInit = productInit;

	function renderProductImage(id) {
		var $el = $('.product__gallery-thumb[data-image-id="' + id + '"]');
		var src = $el.find('img').data('high-res-url');
		$('.product__gallery-thumb.active').removeClass('active');
		$el.addClass('active');
		$('.product__gallery-img img').fadeOut(500, function() {
			$('.product__gallery-img img').attr('src', src);
			$('.product__gallery-img').imagesLoaded().done( function( instance ) {
				$('.product__gallery-img img').fadeIn();
			});
			$('.product__gallery-img').imagesLoaded().fail( function( instance ) {
				$('.product__gallery-img img').fadeIn();
			});
		});
	}

	var loadProductRecommendationsIntoSection = function() {
		// Look for an element with class 'product-recommendations'
		var productRecommendationsSection = document.querySelector(".product-recommendations");
		if (productRecommendationsSection === null) { return; }
		// Read product id from data attribute
		var productId = productRecommendationsSection.dataset.productId;
		// Read limit from data attribute
		var limit = productRecommendationsSection.dataset.limit;
		// Build request URL
		var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
		// Create request and submit it using Ajax
		var request = new XMLHttpRequest();
		request.open("GET", requestUrl);
		request.onload = function() {
		  if (request.status >= 200 && request.status < 300) {
			var container = document.createElement("div");
			container.innerHTML = request.response;
			productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
		  }
		};
		request.send();
	};
	
 }(window.fnapp = window.fnapp || {}, jQuery));